/**
 * Mapping between the "regional depth" codes used in the dataset definitions
 * (datasets.json) and the `spatialUnitType` values used in request settings.
 *
 * - "g"  -> "Gemeinde"
 * - "k"  -> "Kreis"
 * - "r"  -> "Raumkategorie"
 * - "vg" -> "Verwaltungsgemeinschaft"
 * - "m"  -> "Metropolregion"
 */
/** Maps a regional depth code to the corresponding spatialUnitType value. */
export function regionalDepthToSpatialUnitType(code) {
    switch (code) {
        case "g":
            return "Gemeinde";
        case "k":
            return "Kreis";
        case "r":
            return "Raumkategorie";
        case "vg":
            return "Verwaltungsgemeinschaft";
        case "m":
            return "Metropolregion";
    }
}
/** Maps a spatialUnitType value back to its regional depth code. */
export function spatialUnitTypeToRegionalDepth(spatialUnitType) {
    switch (spatialUnitType) {
        case "Gemeinde":
            return "g";
        case "Kreis":
            return "k";
        case "Raumkategorie":
            return "r";
        case "Verwaltungsgemeinschaft":
            return "vg";
        case "Metropolregion":
            return "m";
    }
}
/**
 * Returns the spatialUnitType values that are available for a dataset given
 * its regional depth codes. The order follows the given codes.
 */
export function regionalDepthToSpatialUnitTypes(codes) {
    return codes.map(regionalDepthToSpatialUnitType);
}
/**
 * Whether a spatialUnitType is contained in the given regional depth codes.
 */
export function spatialUnitTypeIsInRegionalDepth(spatialUnitType, codes) {
    return codes.includes(spatialUnitTypeToRegionalDepth(spatialUnitType));
}
